const rarity_options = [
  { key: 'all', value: '< 全て >'},
  { key: 'r5', value: '5'},
  { key: 'r4', value: '4'},
  { key: 'r3', value: '3'},
  { key: 'r2', value: '2'},
]

const exclusive_options = [
  { key: 'all', value: '< 全て >'},
  { key: 'c_weapon', value: '[ 武器限定 ]'},
  { key: 'sword', value: '剣'},
  { key: 'blade', value: '刀'},
  { key: 'dagger', value: '短剣'},
  { key: 'axe', value: '斧'},
  { key: 'lance', value: '槍'},
  { key: 'bow', value: '弓'},
  { key: 'wand', value: 'ロッド'},
  { key: 'staff', value: '杖'},
  { key: 'c_element', value: '[ 属性限定 ]'},
  { key: 'flame', value: '火'},
  { key: 'water', value: '水'},
  { key: 'wind', value: '風'},
  { key: 'light', value: '光'},
  { key: 'shadow', value: '闇'}
]

const condition_options = [
  { key: 'all', value: '< 全て >'},
  { key: 'hfl', value: 'HP満タン'},
  { key: 'h70', value: 'HP70%'},
  { key: 'lst', value: '背水の陣'},
  { key: 'dbb', value: 'プロテクトリンク'},
  { key: 'flr', value: '疾風怒涛'},
  { key: 'hts', value: 'ヒット'},
  // { key: 'drg_clw', value: '龍族恩寵'},
  { key: 'stk', value: '強撃'},
  { key: 'stkr', value: 'バースト撃破'},
  { key: 'slyr', value: '獅子奮迅'},
  { key: 'unt', value: '一致団結'},
  { key: 'rsl', value: '起死回生'}
]

const effect_options = [
  { key: 'all', value: '< 全て >'},

  { key: 'c_atk', value: '[ 攻擊タイプ ]'},
  { key: 'skl_dmg', value: 'スキルダメージ'},
  { key: 'str', value: '攻撃力'},
  { key: 'crt_rt', value: 'クリティカル率'},
  { key: 'crt_dmg', value: 'クリティカルダメージ'},
  { key: 'frc_stk', value: 'バーストダメージ'},
  { key: 'enr', value: 'やる気'},

  { key: 'c_pns', value: '[ 特効タイプ ]'},
  { key: 'ovd_pns', value: 'オーバードライブ特効'},
  { key: 'brk_pns', value: 'ブレイク特効'},
  { key: 'psn_pns', value: '毒特効'},
  { key: 'brn_pns', value: '火傷特効'},
  { key: 'frz_pns', value: '凍結特効'},
  { key: 'prl_pns', value: '麻痺特効'},
  { key: 'bln_pns', value: '暗闇特効'},
  { key: 'stn_pns', value: '気絶特効'},
  { key: 'crs_pns', value: '呪い特効'},
  { key: 'bg_pns', value: 'ずぶぬれ特効'},
  { key: 'slp_pns', value: '睡眠特効'},

  { key: 'c_sp', value: '[ 特殊タイプ ]'},
  { key: 'skl_prp', value: '開幕スキルゲージ'},
  { key: 'skl_chr', value: 'スキルチャージ'},
  { key: 'skl_hst', value: 'スキルブースト'},
  { key: 'bf_tm', value: 'バフスキル時間'},
  { key: 'gg_acl', value: 'ゲージブレイク'},
  { key: 'gg_inh', value: 'ゲージディレイ'},

  { key: 'c_drg', value: '[ 竜化タイプ ]'},
  { key: 'shs_prp', value: '開幕竜化ゲージ'},
  { key: 'drg_dmg', value: '竜化中ダメージアップ'},
  { key: 'drg_tm', value: '竜化時間'},
  { key: 'drg_clw', value: '竜の恩寵・攻'},

  { key: 'c_dfn', value: '[ 防禦タイプ ]'},
  { key: 'hp', value: 'HP'},
  { key: 'dfn', value: '防御力'},
  { key: 'shl_prp', value: '開幕ダメージシールド'},

  { key: 'c_dbf_rs', value: '[ 状態異常耐性タイプ ]'},
  { key: 'afl_grd', value: '状態異常無効'},
  { key: 'psn_rs', value: '毒耐性'},
  { key: 'brn_rs', value: '火傷耐性'},
  { key: 'frz_rs', value: '凍結耐性'},
  { key: 'prl_rs', value: '麻痺耐性'},
  { key: 'bln_rs', value: '暗闇耐性'},
  { key: 'stn_rs', value: '気絶耐性'},
  { key: 'crs_rs', value: '呪い耐性'},
  { key: 'bg_rs', value: 'ずぶぬれ耐性'},
  { key: 'slp_rs', value: '睡眠耐性'},

  { key: 'c_el_rs', value: '[ 属性耐性タイプ ]'},
  { key: 'flm_rs', value: '火属性耐性'},
  { key: 'wtr_rs', value: '水属性耐性'},
  { key: 'wnd_rs', value: '風属性耐性'},
  { key: 'lgh_rs', value: '光属性耐性'},
  { key: 'shd_rs', value: '闇属性耐性'},

  { key: 'c_rc_rs', value: '[ 種族耐性タイプ ]'},
  { key: 'hmd_rs', value: '真・碧竜耐性'},
  { key: 'hbr_rs', value: '真・緋竜耐性'},
  { key: 'hmr_rs', value: '真・青竜耐性'},
  { key: 'hjp_rs', value: '真・輝竜耐性'},
  { key: 'hzd_rs', value: '真・闇竜耐性'},
  { key: 'md_rs', value: '碧竜耐性'},
  { key: 'br_rs', value: '緋竜耐性'},
  { key: 'mr_rs', value: '青竜耐性'},
  { key: 'jp_rs', value: '輝竜耐性'},
  { key: 'zd_rs', value: '闇竜耐性'},

  { key: 'c_hl', value: '[ 回復タイプ ]'},
  { key: 'rcv_ptn', value: '回復スキル効果'},
  { key: 'hl', value: '治癒'},

  { key: 'c_other', value: '[ その他 ]'},
  { key: 'exp', value: 'プレイヤーの経験値がアップ'}
]

const type_options = [
  { key: 'all', value: '< 全て >'},
  { key: 'common', value: 'レギュラー'},
  { key: 'seasonal', value: '限定'},
  { key: 'event', value: 'イベント'},
  { key: 'collab', value: 'コラボ'},
  { key: 'promo', value: '特典'}
]

const Options = {
  rarity    : rarity_options,
  exclusive : exclusive_options,
  condition : condition_options,
  effect    : effect_options,
  type      : type_options
}

export default Options